<template>
  <el-dialog :title="$t('material.selSupplierTitle')" :visible="isShow" width="65%" @close="cancel('showSupplierDialog')">
    <div>
      <el-form :model="queryCondition" ref="queryCondition" label-width="140px">
        <el-row>
          <el-col :span="9">
            <el-form-item label="Category1" prop="categoryLevel1Id">
              <el-select v-model="queryCondition.categoryLevel1Id" clearable @change="changeCategory1()">
                <el-option :key="index" v-for="(item,index) in categoryList1" :label="item.name" :value="item.tmCategoryId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="9">
            <el-form-item label="Category2" prop="categoryLevel2Id">
              <el-select v-model="queryCondition.categoryLevel2Id" clearable @change="changeCategory2()">
                <el-option :key="index" v-for="(item,index) in categoryList2" :label="item.name" :value="item.tmCategoryId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="9">
            <el-form-item label="Category3" prop="categoryLevel3Id">
              <el-select v-model="queryCondition.categoryLevel3Id" clearable>
                <el-option :key="index" v-for="(item,index) in categoryList3" :label="item.name" :value="item.tmCategoryId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="center">
          <el-col :span="4">
            <el-button @click="queryData(1)" type="primary">{{$t('common.search')}}</el-button>
            <el-button @click="restQueryForm" type="primary">{{$t('common.reset')}}</el-button>
          </el-col>
        </el-row>
      </el-form>
      <div style="padding-bottom: 15px;"></div>
      <el-table :data="tableList" row-key="tmFiveBitCodeId" ref="tableList" border highlight-current-row max-height="420">
        <el-table-column align="center" width="56" :label="$t('common.select')">
          <template slot-scope="scope">
            <el-radio v-model="radioVal" :label="scope.row.tmFiveBitCodeId">&nbsp;</el-radio>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="categoryLevel1Name" :label="$t('material.categoryLevel1Name')" min-width="120"></el-table-column>
        <!--GRI第一层分类-->
        <el-table-column show-overflow-tooltip prop="categoryLevel2Name" :label="$t('material.categoryLevel2Name')" min-width="140"></el-table-column>
        <el-table-column show-overflow-tooltip prop="categoryLevel3Name" :label="$t('material.categoryLevel3Name')" min-width="140"></el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount"></el-pagination>
      </div>
      <div class="foot-btn" style="padding-top: 10px;text-align: center">
        <el-button type="primary" @click="confirmMethod">{{ $t('common.confirm') }}</el-button>
        <el-button @click="cancel('showSupplierDialog')">{{ $t('common.cancel') }}</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import IcSelect from "@/components/common/icSelect";
import commonFunction from "@/utils/dataTableUtils";
import { apiService } from "@/api/material/material-master-data";
import GRIApi from "@/api/material/GRI";

export default {
  extends: commonFunction,
  components: {
    IcSelect
  },
  props: {
    isShow: {
      type: Boolean,
      default: true
    },
    createFun: {
      type: Function,
      default: function () {
      }
    }
  },
  data() {
    return {
      queryCondition: {
        pageNum: 1,
        pageSize: 15,
        categoryLevel1Id: null,
        categoryLevel2Id: null,
        categoryLevel3Id: null,
      },
      tableList: [],
      totalCount: 0,
      categoryList1: [],
      categoryList2: [],
      categoryList3: [],
      radioVal: null,
    };
  },
  mounted() {
    this.queryData();
    this.getCategoryList();
  },
  methods: {
    queryData(val) {
      let that = this;
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      GRIApi.getList(this.queryCondition).then((res) => {
        that.tableList = res.resultData;
        that.totalCount = res.totalCount;
      });
    },

    getCategoryList() {
      apiService.findCategory({ categoryLevel: 1 }).then((res) => {
        this.categoryList1 = res.data;
      });
    },
    //根据选中Category1查询Category2
    changeCategory1() {
      this.queryCondition.categoryLevel2Id = null
      this.queryCondition.categoryLevel3Id = null
      this.categoryList2 = []
      this.categoryList3 = []
      apiService.findCategory({ categoryLevel: 2, pid: this.queryCondition.categoryLevel1Id }).then((res) => {
        this.categoryList2 = res.data;
      });
    },
    //根据选中Category2查询Category3
    changeCategory2() {
      this.queryCondition.categoryLevel3Id = null
      this.categoryList3 = []
      apiService.findCategory({ categoryLevel: 3, pid: this.queryCondition.categoryLevel2Id }).then((res) => {
        this.categoryList3 = res.data;
      });
    },
    // 确认选中
    confirmMethod() {
      if (!!this.radioVal) {
        const changeRow = this.tableList.filter(item => item.tmFiveBitCodeId === this.radioVal)
        this.createFun(changeRow[0]);
        this.radioVal = null
      } else {
        this.$message({
          type: "error",
          message: this.$t("common.pleaseSelectData")
        });
      }
    }
  }
};
</script>

<style scoped lang="scss"></style>
